import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {PreviewCardOutlet} from '@github-ui/preview-card'
import {Outlet} from '@github-ui/react-router'
import {SharedLayout} from '@github-ui/shared-dashboard-surface/components/shared/SharedLayout'

import {
  RepoPullsDashboardCollapsibleSidebar,
  RepoPullsDashboardHeader,
  RepoPullsDashboardSidebar,
} from './RepoPullsDashboardHeader'

export function RepoPullsDashboardLayout() {
  const sidebarLayoutEnabled = isFeatureEnabled('pulls_dashboard_sidebar_layout')

  return (
    <AnalyticsProvider
      appName="repo-pulls-dashboard-surface"
      category="Repository Pull Requests"
      metadata={{page: 'repo-pulls-dashboard'}}
    >
      <div data-issue-and-pr-hovercards-enabled>
        {sidebarLayoutEnabled ? (
          <SidebarPageLayout storageKey="pulls-dashboard-sidebar">
            <SidebarPageLayout.Header>
              <RepoPullsDashboardHeader />
            </SidebarPageLayout.Header>
            <SidebarPageLayout.Sidebar aria-label="Pull requests navigation" dialogTitle="Pull requests">
              <RepoPullsDashboardCollapsibleSidebar />
            </SidebarPageLayout.Sidebar>
            <SidebarPageLayout.Content as="div">
              <Outlet />
            </SidebarPageLayout.Content>
          </SidebarPageLayout>
        ) : (
          <SharedLayout header={<RepoPullsDashboardHeader />} sidebar={<RepoPullsDashboardSidebar />} />
        )}
        <PreviewCardOutlet />
      </div>
    </AnalyticsProvider>
  )
}
